// Privacy policy (owner, 5 Nov 2026: "can you also update /term-condition and
// /privacy-policy"): the same words, in the same order, in the legal layout
// (components/landing/LegalPage): night hero, "On this page", a reading column and a
// closing card with the contact email. The words are the owner's, from /languages.
import React from 'react';
import { useSelector } from 'react-redux';
import { PrivacyTipOutlined } from '@mui/icons-material';
import LegalPage, { LegalP, LegalList, legalHeading } from '../components/landing/LegalPage';
import { useSiteWords } from '../components/landing/SitePage';

export default function PrivacyPolicy(props) {
  const { t, L } = useSiteWords();
  const settings = useSelector((state) => state.settingsdata.settings) || {};
  // Plain helpers (not components), so nothing remounts on a re-render.
  const P = (k) => <LegalP key={k}>{t(k)}</LegalP>;
  const List = (keys) => <LegalList key={keys[0]} items={keys.map((k) => t(k))} />;
  const section = (id, heading, body) => ({ id: 'pp-' + id, heading: legalHeading(heading), body });

  const sections = [
    section(
      'info',
      t('privacy_policy_heading_info'),
      <>
        {P('privacy_policy_info_para1')}
        {List(['privacy_policy_info_list1', 'privacy_policy_info_list2', 'privacy_policy_info_list3', 'privacy_policy_info_list4'])}
        {P('privacy_policy_info_para2')}
        {P('privacy_policy_info_para3')}
        {P('privacy_policy_info_para4')}
        {List(['privacy_policy_info_list5', 'privacy_policy_info_list6', 'privacy_policy_info_list7'])}
        {P('privacy_policy_info_para5')}
      </>
    ),
    section('log', t('privacy_policy_heading_log'), P('privacy_policy_log_para1')),
    section(
      'cookies',
      t('privacy_policy_heading_cookie'),
      <>
        {P('privacy_policy_cookie_para1')}
        {P('privacy_policy_cookie_para2')}
      </>
    ),
    section(
      'providers',
      t('privacy_policy_heading_service'),
      <>
        {P('privacy_policy_service_para1')}
        {List(['privacy_policy_service_list1', 'privacy_policy_service_list2', 'privacy_policy_service_list3', 'privacy_policy_service_list4'])}
        {P('privacy_policy_service_para2')}
      </>
    ),
    section('security', t('privacy_policy_heading_security'), P('privacy_policy_security_para1')),
    section('links', t('privacy_policy_heading_link'), P('privacy_policy_link_para1')),
    section('children', t('privacy_policy_heading_children'), P('privacy_policy_children_para1')),
    section(
      'delete',
      t('delete_account_lebel'),
      <>
        {P('delete_account_msg')}
        {P('delete_account_subheading')}
        {List(['delete_account_para1', 'delete_account_para2'])}
      </>
    ),
    section(
      'changes',
      t('privacy_policy_heading_change_privacy'),
      <>
        {P('privacy_policy_change_privacy_para1')}
        {P('privacy_policy_change_privacy_para2')}
      </>
    ),
  ];

  return (
    <LegalPage
      mainId="pp-main"
      heroId="pp-title"
      icon={<PrivacyTipOutlined />}
      title={t('privacy_policy')}
      sub={L('lg_privacy_sub', 'What information we collect, how we use it, and how to delete your account.')}
      intro={
        <>
          {P('privacy_policy_para1')}
          {P('privacy_policy_para2')}
          {P('privacy_policy_para3')}
        </>
      }
      sections={sections}
      closing={{ id: 'pp-contact', heading: legalHeading(t('privacy_policy_heading_contact')), text: t('privacy_policy_contact_para1'), email: settings.contact_email }}
      {...props}
    />
  );
}
